module.exports = require('./dist/lib/link')
